import BSelect from "@/components/singles/BSelect/component.vue";
import BMMenu from "@/components/singles/BMMenu/component.vue";
import BDDM from "@/components/singles/BDDM/component.vue";
import EditableText from "@/components/singles/EditableText/component.vue";
import Key from "@/components/main/license/key/component.vue";
import Confirm from "@/components/main/Confirm.vue";

import _ from "lodash";

export default {
  name: "",
  components: {
    BSelect,
    BMMenu,
    BDDM,
    EditableText,
    Key,
    Confirm
  },
  props: [],
  data() {
    return {
      confirmVisible: false,
      toConfirm: null,
      intervalId: null,
      subs: [],
      availableSubs: [],
      items: [],
      licenseTypes: null,
      firstLoadDone: false
    };
  },
  computed: {
    orderedItems: function() {
      return _.orderBy(this.items, "name");
    }
  },

  async created() {
    await this.GetItems();
    await this.GetFreeSubs();
    this.firstLoadDone = true;

    if (this.items.length === 0) {
      this.intervalId = setInterval(() => {
        this.GetItems();

        if (this.items.length !== 0) {
          clearInterval(this.intervalId);
        }
      }, 5000);
    }
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    SubAdded(item, obj) {
      this.availableSubs = this.availableSubs.filter(
        x => x.subscription.uid !== obj.subscription.uid
      );

      this.$helpers.ShowStatus(
        "Saved. Rembember to update the license information on your server (see instruction #3).",
        0,
        "success"
      );
    },

    SubRemoved(item, obj) {
      this.availableSubs.push(obj);

      this.$helpers.ShowStatus(
        "Saved. Rembember to update the license information on your server (see instruction #3).",
        0,
        "success"
      );
    },

    filteredItems: (items, filter) => {
      if (items) {
        return items.filter(item => {
          if (!item.edit) {
            if (item.user.deleted.toString() === filter || filter === "all") {
              return true;
            } else {
              return false;
            }
          }

          return true;
        });
      }
    },

    MergeSubs(serverSubs) {
      let arr = [...serverSubs, ...this.availableSubs];
      return arr;
    },

    async GetItems() {
      let res = await this.$helpers.PostApi("get/servers", {});

      this.items = res.map(x => {
        x.subscriptions = x.subscriptions.filter(y => y.subscription);
        return x;
      });
    },

    async GetFreeSubs() {
      let result = await this.$helpers.PostApi("get/availableSubscriptions");
      this.availableSubs = result;
    },

    async DeleteItem(item) {
      item.isLoading = true;

      await this.$helpers.PostApi("delete/server", {
        uid: item.server.uid
      });

      this.$set(
        this,
        "items",
        this.items.filter(x => x.server.uid !== item.server.uid)
      );
      item.isLoading = false;
    }
  }
};
